export default __webpack_public_path__ + "static/media/cropped_image.8cdca6e1.svg";